import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { Button } from 'components/common/button/Button';
import { SummaryCard, TransactionList, BalanceList } from 'components/cost';
import { usePaymentList } from 'hooks/usePayment';
import { paymentStore } from 'store/paymentStore';
import { calculateSettlement } from 'common/utils/settlementCalculator';
import './CostResult.css';

export const CostResult = () => {
    const navigate = useNavigate();
    const { meetingId } = useParams();
    const { data: paymentData } = usePaymentList();

    useEffect(() => {
        if (meetingId) {
            paymentStore.onGetPaymentList(meetingId);
        }
    }, [meetingId]);

    const payments = paymentData?.data || [];

    const settlement = useMemo(() => {
        return calculateSettlement(payments);
    }, [payments]);

    const {
        totalAmount,
        perPersonAmount,
        balances,
        transactions,
        expenses
    } = settlement;

    const handleShare = () => {
        navigate(`/cost/share/${meetingId}`);
    };

    const handleAddMore = () => {
        navigate(`/cost/${meetingId}`);
    };

    return (
        <div className="cost-result-wrapper">
            <Header title="정산 결과" isSubPage />

            <div className="cost-result-content">
                <SummaryCard
                    totalAmount={totalAmount}
                    perPersonAmount={perPersonAmount}
                    expenses={expenses}
                />

                <TransactionList transactions={transactions} />

                <BalanceList balances={balances} />

                <div className="result-notice">
                    <div className="notice-icon">💡</div>
                    <div className="notice-text">
                        정산 결과를 참여자들과 공유할 수 있어요
                    </div>
                </div>
            </div>

            <div className="cost-result-footer">
                <button className="add-more-button" onClick={handleAddMore}>
                    ✏️ 나의 지출 내역 입력
                </button>
                <Button
                    text="결과 공유하기"
                    onPress={handleShare}
                />
            </div>
        </div>
    );
};
